<template>
  <header class="top-bar">
    <div class="logo">
      <img src="/demo/images/apar-holdings-logo.jpeg" alt="Company Logo" />
    </div>
    <div class="actions">
      <button @click="logout">Sair da Aplicação</button>
      <img src="/demo/images/auditplan-logo.png" alt="Product Logo" class="product-logo" />
      <!-- <button @click="toggleTheme">Change Theme</button> -->
    </div>
  </header>
</template>

<script setup lang="ts">
import { useRouter } from 'vue-router';

const router = useRouter();

const toggleTheme = () => {
  // Logic to toggle theme
  console.log('Theme toggled');
};

const logout = () => {
  // Limpa os dados de autenticação
  localStorage.removeItem('user');
  localStorage.removeItem('token');

  // Redireciona para a rota de login
  router.push('/auth/login');
  console.log('Usuário deslogado e redirecionado para a página de login');
};
</script>

<style scoped>
.top-bar {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 1rem;
  background-color: #ffffff;
  border-bottom: 1px solid #dee2e6;
}

.logo img {
  height: 40px;
}

.actions {
  display: flex;
  align-items: center;
  gap: 1rem;
}

.product-logo {
  height: 40px;
}
</style>
